import React from 'react'
import styled from '@emotion/styled'
import { components, type PlaceholderProps } from 'react-select'
import { FilterIcon } from '@instacart/ids-core'
import { spacing } from '@retailer-platform/shared-components'
import { type FiltersDropdownOption } from 'domains/aggregate-store-performance/components/filters-dropdown/utils/FiltersDropdown.types'

const PlaceHolderContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
})

export const Placeholder = (props: PlaceholderProps<FiltersDropdownOption>) => (
  <components.Placeholder {...props}>
    <PlaceHolderContainer>
      <FilterIcon style={{ marginRight: spacing.X8 }} />
      {props.children}
    </PlaceHolderContainer>
  </components.Placeholder>
)
